const PlaceholderHeadshot = (
  props: Omit<JSX.IntrinsicElements['img'], 'src'>,
) => {
  return <img src="/placeholder_headshot.png" {...props} />;
};

export default PlaceholderHeadshot;
